import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-ent-select-modal',
  templateUrl: './ent-select-modal.component.html',
  styleUrls: ['./ent-select-modal.component.css']
})
export class EntSelectModalComponent implements OnInit, OnChanges {

  @Input() isVisible: boolean;
  @Input() options: Array<any>;
  @Output() update = new EventEmitter<any>();

  selectedOption;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.selectedOption) {
      const options = changes['options'].currentValue;
      if (options && options.length) {
        this.selectedOption = options[0].ent;
      }
    }
  }

  handleOk() {
    this.isVisible = false;
    this.update.emit(this.selectedOption);
  }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/userEnt/ent-select-modal/ent-select-modal.component.ts